// Supermove
import {gql} from '@supermove/graphql';
import {Currency, Percent, withFragment} from '@supermove/utils';

const KIND_PERCENTAGE = 'PERCENTAGE';
const KIND_AMOUNT = 'AMOUNT';

const KIND_DISPLAY_PERCENTAGE = 'Percentage';
const KIND_DISPLAY_AMOUNT = 'Flat Fee';

const getDisplayKind = withFragment(
  (billModifier) => {
    switch ((billModifier as any).kind) {
      case KIND_PERCENTAGE:
        return KIND_DISPLAY_PERCENTAGE;
      case KIND_AMOUNT:
        return KIND_DISPLAY_AMOUNT;
      default:
        return null;
    }
  },
  gql`
    fragment BillModifier_getDisplayKind on BillModifier {
      kind
    }
  `,
);

const getDisplayName = withFragment(
  (billModifier) => {
    switch ((billModifier as any).kind) {
      case KIND_PERCENTAGE:
        return `${(billModifier as any).name} (${Percent.display((billModifier as any).percentage)})`;
      case KIND_AMOUNT:
      default:
        return (billModifier as any).name;
    }
  },
  gql`
    fragment BillModifier_getDisplayName on BillModifier {
      kind
      name
      percentage
    }
  `,
);

const getDisplayValue = withFragment(
  (billModifier) => {
    switch ((billModifier as any).kind) {
      case BillModifier.KINDS.AMOUNT:
        return Currency.display((billModifier as any).amount, {shouldHideCentsIfZero: true});
      case BillModifier.KINDS.PERCENTAGE:
        return Percent.display((billModifier as any).percentage);
      default:
        return null;
    }
  },
  gql`
    fragment BillModifier_getDisplayValue on BillModifier {
      kind
      percentage
      amount
    }
  `,
);

const getDisplayTotal = withFragment(
  (billModifier, {isSubtotalAvailable}) => {
    if ((billModifier as any).kind === KIND_AMOUNT) {
      return Currency.format({
        value: (billModifier as any).estimateTotalMin,
        shouldHideCentsIfZero: true,
      });
    }

    if (!isSubtotalAvailable) {
      return 'TBD';
    }

    return Currency.formatRange({
      min: (billModifier as any).estimateTotalMin,
      max: (billModifier as any).estimateTotalMax,
      shouldHideCentsIfZero: true,
    });
  },
  gql`
    fragment BillModifier_getDisplayTotal on BillModifier {
      kind
      estimateTotalMin
      estimateTotalMax
    }
  `,
);

const BillModifier = {
  KINDS: {
    AMOUNT: KIND_AMOUNT,
    PERCENTAGE: KIND_PERCENTAGE,
  },

  KINDS_DROPDOWN_OPTIONS: [
    {label: KIND_DISPLAY_AMOUNT, value: KIND_AMOUNT},
    {label: KIND_DISPLAY_PERCENTAGE, value: KIND_PERCENTAGE},
  ],

  KINDS_DROPDOWN_OPTIONS_ALT: [
    {label: `${KIND_DISPLAY_AMOUNT} (After Subtotal)`, value: KIND_AMOUNT},
    {label: `${KIND_DISPLAY_PERCENTAGE} (After Subtotal)`, value: KIND_PERCENTAGE},
  ],

  KINDS_TAB_OPTIONS: [
    {label: KIND_DISPLAY_AMOUNT, value: KIND_AMOUNT},
    {label: KIND_DISPLAY_PERCENTAGE, value: KIND_PERCENTAGE},
  ],

  getDisplayKind,
  getDisplayName,
  getDisplayTotal,
  getDisplayValue,
};

export default BillModifier;
